import {
  PdfGen,
  PdfUnit,
  PdfSize,
  PdfRect,
  PdfPoint,
  PdfBrush,
  PdfFont,
  ETextAlign,
} from '../../pdf/pdf';
import { ILayoutImageGen } from '../layoutImage';
import { OptsImage } from '../optsImage';
import { IItemCount } from '@educraft/base';
import { GUtil } from '../../pdf/gutil';
import '../../pdf/draw/primitives';
import '../../pdf/draw/string';
import '../../pdf/draw/image';
import '../../pdf/draw/transforms';

/**
 * Nebe_Peklo_Raj (Heaven Hell Paradise) - Foldable fortune teller game
 *
 * Layout: 1 portrait page.
 * 4×4 grid with fold lines creating a paper fortune teller.
 * Corner images are rotated, numbered panels around center.
 *
 * Migrated from C# EduFrame.Img10.Generators.Nebe_Peklo_Raj
 */
export class NebePekloRaj implements ILayoutImageGen, IItemCount {
  countDefault(): number {
    return 4;
  }
  countMin(): number {
    return 4;
  }
  countMax(): number {
    return 4;
  }

  public async generate(pdf: PdfGen, opts: OptsImage): Promise<void> {
    const margin = PdfUnit.FromMillimeters(5);
    const size = PdfSize.A4.width - 2 * margin;
    const size4 = { width: size / 4, height: size / 4 };
    const origin = new PdfPoint(margin, (PdfSize.A4.height - size) / 2);
    const rect = new PdfRect(origin.x, origin.y, size, size);
    const bigFont = new PdfFont(PdfFont.FONT_NAME, 48);

    const page = pdf.addPage();

    const P = (x: number, y: number) =>
      new PdfPoint(origin.x + x * size4.width, origin.y + y * size4.height);

    // Draw fold lines (symmetric)
    const drawL = (x1: number, y1: number, x2: number, y2: number) => {
      page.drawLine(GUtil.foldPen, P(x1, y1), P(x2, y2));
      page.drawLine(GUtil.foldPen, P(4 - x1, y1), P(4 - x2, y2));
      page.drawLine(GUtil.foldPen, P(x1, 4 - y1), P(x2, 4 - y2));
      page.drawLine(GUtil.foldPen, P(4 - x1, 4 - y1), P(4 - x2, 4 - y2));
    };

    drawL(0, 1, 1, 1);
    drawL(1, 0, 1, 1);
    drawL(0, 2, 2, 0);
    drawL(1, 1, 2, 2);

    // Main fold lines
    page.drawLine(GUtil.foldPen, P(0, 2), P(4, 2));
    page.drawLine(GUtil.foldPen, P(2, 0), P(2, 4));

    // Draw numbers with rotation
    for (let i = 0; i < 4; i++) {
      page.save();
      page.rotateAtTransform(i * 90, new PdfPoint(rect.centerX, rect.centerY));

      const r1 = new PdfRect(P(1, 0).x, P(1, 0).y, P(2, 1).x - P(1, 0).x, P(2, 1).y - P(1, 0).y);
      const r2 = new PdfRect(P(2, 0).x, P(2, 0).y, P(3, 1).x - P(2, 0).x, P(3, 1).y - P(2, 0).y);

      page.drawString(` ${i * 2 + 1} `, bigFont, PdfBrush.Black, null, r1, ETextAlign.TopLeft);
      page.drawString(` ${i * 2 + 2} `, bigFont, PdfBrush.Black, null, r2, ETextAlign.TopRight);

      page.restore();
    }

    // Draw corner images with rotation
    const rects = [
      new PdfRect(P(0, 0).x, P(0, 0).y, size4.width, size4.height),
      new PdfRect(P(3, 0).x, P(3, 0).y, size4.width, size4.height),
      new PdfRect(P(3, 3).x, P(3, 3).y, size4.width, size4.height),
      new PdfRect(P(0, 3).x, P(0, 3).y, size4.width, size4.height),
    ];

    for (let i = 0; i < rects.length && i < opts.list.length; i++) {
      page.save();
      page.rotateAtTransform(i * 90, new PdfPoint(rects[i].centerX, rects[i].centerY));
      page.drawImageCenter(opts.list[i].image, rects[i]);
      page.restore();
    }

    page.drawRectangle(GUtil.cutPen, null, rect);
  }
}
